import { get } from 'common/utils/request';
import { CHAT_URL } from 'common/constants/common';
export var fetchChatUnreadMessagesCountApi = function () {
    return get('/Chats/messages/unread', {}, {
        abortRequestKey: 'chatFetchHasUnreadMessages',
        baseURL: CHAT_URL,
    });
};
